import { type ReactNode } from 'react';

import { RiInformationLine as InfoIcon } from '@remixicon/react';

import { ButtonIcon } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

type SectionInfoTooltipProps = {
  children: NonNullable<ReactNode>;
};

const SectionInfoTooltip = ({ children }: SectionInfoTooltipProps) => (
  <TooltipRoot>
    <ButtonIcon variant="tertiary" size="small" aria-label="More information">
      <InfoIcon aria-hidden />
    </ButtonIcon>
    <Tooltip>{children}</Tooltip>
  </TooltipRoot>
);

SectionInfoTooltip.displayName = 'Section.InfoTooltip';

export default SectionInfoTooltip;
